import { Box, Chip, IconButton, Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import Confirm from "components/Dialog";
import { DeleteIcon, EditIcon } from "components/Icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { destroy } from "store/evaluation/admin-artifact";

export default function ArtifactList({ artifactList }) {
  const headers = ['Artifact File', 'Explanation', 'Indicators', 'Actions']
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [confirm, setConfirm] = useState(false)
  const [toDelete, setToDelete] = useState(null)
  const { t } = useTranslation()

  const onDelete = (id) => {
    setToDelete(id)
    setConfirm(true)
  }

  const onConfirm = () => {
    setConfirm(false)
    dispatch(destroy({ id: toDelete }))
  }

  return (
    <Box width={'100%'}>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                {headers.map((header, index) => (
                <TableCell key={index}>
                    {t(header)}
                </TableCell>
              ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {artifactList?.map((item, index) => (
                <TableRow key={`artifact-${index}`}>
                  <TableCell>
                    <Link href={item?.file?.location} target="_blank">{item?.file?.name}</Link>
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '400px',
                      }}
                    >
                      {item?.explanation}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box display={'flex'} gap={1}>
                      {item.indicatorIds?.map((ind, index) => (
                        <Chip key={`artifact-${index}`} label={ind} size="small" />
                      ))}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <IconButton onClick={() => navigate(`/admin-evaluation/evaluation/artifact/${item.id}`)}>
                        <EditIcon />
                    </IconButton>
                    <IconButton onClick={() => onDelete(item.id)}>
                        <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
              <Confirm open={confirm} onClose={() => setConfirm(false)} onConfirm={onConfirm} />
        </TableContainer>
    </Box>
  )
}
